import NewspaperPreview from '../../pages/newspaper/NewspaperPreview'
import multiguard from 'vue-router-multiguard'
import authGuard from '../../guards/auth.guard'

const newspaperpreview = {
  path: '/preview',
  name: 'NewspaperPreview',
  component: NewspaperPreview,
  meta: {
    title: 'Page Title',
  },
  beforeEnter: multiguard([authGuard])

}

export default newspaperpreview
